export default {
  getHead: () => {
    return [{name: '회사명'},{name: '작업기간'}, {name: '작업내용'}, {name: '장비종류'}, {name: '기종'}, {name: '규격'}, {name: '운전원'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 회사명
        case 1: return `${func.getContent(value).sDate} ~ ${func.getContent(value).eDate}` // 작업기간
        case 2: return func.getContent(value).작업내용 // 작업내용
        case 3: return func.getContent(value).장비종류 // 장비종류
        case 4: return func.getContent(value).기종 // 기종
        case 5: return func.getContent(value).규격 // 규격
        case 6: return func.getContent(value).운전원 // 운전원
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'content$body.sDate'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '회사명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '부서명': returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    case '작업내용': returnData.push('content$body."작업내용"*%[:default_skw]%'); break
    case '장비종류': returnData.push('content$body."장비종류"*%[:default_skw]%'); break
    case '기종': returnData.push('content$body."기종"*%[:default_skw]%'); break
    case '규격': returnData.push('content$body."규격"*%[:default_skw]%'); break
    case '운전원': returnData.push('content$body."운전원"*%[:default_skw]%'); break
    }

    return returnData
  },
}
